import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/users/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { INVENTORY_SORT, PRODUCT_SORT, TRANG_THAI_BAN_HANG } from '../../constants/productStatus';
import InputTitleTop from '../../components/InputTitleTop';
import SelectTitleTop from '../../components/SelectTitleTop';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import FileDownload from 'js-file-download'
import IconCalendar from "../../assets/images/icon/ic_calendar-black.svg";
import { baseUrl } from '../../constants/environment';
import IconLock from '../../assets/images/icon-lock.png';
import IconUnLock from '../../assets/images/icon-unlock.png';
import IconPlus from '../../assets/images/icon-plus.png';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import { checkRole } from "../../helpers/Roles";
const configPage = {
    titlePage: 'Thông tin số dư sổ quỹ',
    pathPage: '/setting/fundaccount',
    column: 6,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        page: 1,
        limit: 25,
    }
}

const StatusList = [
    {
        value: "",
        label: "-Loại sổ quỹ-"
    },
    {
        value: "account",
        label: "Tài khoản"
    },
    {
        value: "cash",
        label: "Tiền mặt"
    },
]


const List: React.FC<Props> = (props: Props) => {
    console.log(props, "propsF");

    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [type, setType] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState({});
    const [ids, setIds] = useState([]);
    const router = useHistory()
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
    }, []);

    useEffect(() => {
        loadData();
        setFilterParams({
          page: page,
          limit: limit,
          ...filter,
        });
      }, [filter, page, limit]);
    
    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const setFilterParams = (params: any) => {
        console.log(params, "params");

        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadData = async () => {
        try {
            setLoading(true);
            const formData = {
                page: 1,
                limit: 200,
                ...filter,
            }
            const url = `${baseUrl}/fundaccount`;
            const response: any = await APIClient.GET(url, formData);

            if (response.error) {
                toast.error(response.error);
            } else if (response.response?.data) {
                const { data: responseData } = response.response;
                console.log("responsehihi", responseData);
                // Tạo mảng chứa các phần tử có type là "account"
                const accountData = responseData.filter((item: any) => item.type === "account" && item.status == 1);
                setType(accountData);
                 // Tạo mảng chứa các phần tử có type là "cash"
                const cashData = responseData.filter((item: any) => item.type === "cash" && item.status == 1);
                setData(cashData);
                setTotalElements(response.response?.total);
            }
        } catch (error) {
            console.error("Error while loading data:", error);
            toast.error("An error occurred while loading data");
        } finally {
            setLoading(false);
        }
    }

    const containerStyle = {
        display: 'flex',
    };

    const divStyle = {
        width: '700px',
        marginRight: '20px', // Để tạo khoảng cách giữa hai div
    };
    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
          ...prevState,
          filter: value,
        }));
      };
    const handleChangeFilterDate = (date: any) => {
    if (date.length === 2) {
        const from = moment(date[0]).startOf("day").unix() * 1000;
        const to = moment(date[1]).endOf("day").unix() * 1000;
        setFilter({
        ...filter,
        from: from,
        to: to,
        });
    }
    };

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
              <Col xl={3}>
                <InputGroup className="form-control picker-custom">
                  <Flatpickr
                    value={[
                      new Date(
                        moment(Number(filter.from)).startOf("day").unix() * 1000
                      ),
                      new Date(
                        moment(Number(filter.to)).startOf("day").unix() * 1000
                      ),
                    ]}
                    onChange={(date: any) => handleChangeFilterDate(date)}
                    options={{
                      mode: "range",
                      locale: Vietnamese,
                      dateFormat: "d/m/Y",
                    }}
                    placeholder="Từ - đến"
                  />
                  <div
                    className="icon-clear"
                    style={{ right: 23 }}
                    onClick={() => {
                      setFilter({ ...filter, from: undefined, to: undefined });
                    }}
                  >
                    <i className="uil-times mr-1"></i>
                  </div>
                  <InputGroupAddon
                    addonType="append"
                    className="d-flex align-items-center"
                  >
                    <img src={IconCalendar} alt="icon" />
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <br />
            <div style={containerStyle}>
                <div style={divStyle}>
                    <PageBody>
                        <DataTitle />
                        <DataTableList
                            user={props?.user}
                            data={data} loading={loading}
                            page={page} limit={limit}
                            configPage={configPage}
                            history={props.history}
                            handleActionModal={(data: any) => handleActionModal(data)}
                        />
                    </PageBody>
                </div>

                <div style={divStyle}>
                    <PageBody>
                        <DataTitles />
                        <DataTableLists
                            user={props?.user}
                            type={type} loading={loading}
                            page={page} limit={limit}
                            configPage={configPage}
                            history={props.history}
                            handleActionModal={(data: any) => handleActionModal(type)}
                        />
                    </PageBody>
                </div>

                <div className="bottom-action">
                    <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                </div>

            </div>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal
                  closeModal={() => setIsOpen(false)}
                  action = {action}
                />
            </ModalPopup>
        </React.Fragment>
    );
}

const DataTableLists = (props: any) => {
    const { type, filter, loading, limit, page, is_draft, configPage, handleActionModal, user } = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (

            <thead>
                <tr>

                    <th style={{ minWidth: 120 }}>Mã TK sổ quỹ</th>
                    <th style={{ minWidth: 120 }}>Tài khoản quỹ</th>
                    <th style={{ minWidth: 120 }}>Số dư TK quỹ</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={type.length || limit} />
        }
        if (type.length === 0) {
            return <RowEmpty column={configPage.column} title="Danh sách sổ quỹ trống!" />;
        }

        const getAddressText = (street: string, ward: string, district: string, province: string) => {
            const AddArr = [street, ward, district, province]
            if (street == "") {
                return `${ward}, ${district}, ${province}`
            } else {
                return AddArr?.join(', ');
            }
        }

        const gotoDetail = (item: any) => {
            if(!checkRole(props?.user?.roles, ['viewFundaccount'], props?.user?.role)){
                handleActionModal({type: 'roles', data: item})
                return
            }
            router?.push(`/setting/fundaccount/${item?.id}/view`)
        }
        const SetType = (type: string) => {
            let textColor = "";
            switch (type) {
                case 'cash':
                    textColor = "blue"; // Màu chữ cho Tiền mặt là Xanh dương
                    return <span style={{ color: textColor }}>Tiền mặt</span>;
                case 'account':
                    textColor = "orange"; // Màu chữ cho Tài khoản là Cam
                    return <span style={{ color: textColor }}>Tài khoản</span>;
                default:
                    return "";
            }
        }
        const getCheckTotal = (total: number) => {
            const numberFormat = new Intl.NumberFormat();
            if (total < 0) {
                return <span className={"text-danger"}>{numberFormat.format(total)}</span>;
            } else {
                return <span className={"text-success"}>{numberFormat.format(total)}</span>;
            }
        };
        const styleTds = {
            fontWeight: 'bold',
            backgroundColor: '#F8F8FF',
            borderRadius: '10px',
            border: '1px solid white',
        };
        return (
            <tbody style={{ borderSpacing: '20px' }}>
                {type &&
                    type.map((item: any, index: number) => {
                        return (
                            <tr key={index}>
                                <td onClick={() => gotoDetail(item)} style={{ ...styleTds, paddingRight: '10px' }}>
                                    {item?.code}
                                </td>
                                <td onClick={() => gotoDetail(item)} style={{ ...styleTds, paddingRight: '10px' }}>{item?.name}</td>
                                <td onClick={() => gotoDetail(item)} style={{ ...styleTds, paddingLeft: '10px' }}>
                                    {getCheckTotal(item?.total)}
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        );
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            {/* {loading && <Loader />} */}
        </div>
    );
}

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, is_draft, configPage, handleActionModal, user } = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (

            <thead>
                <tr>

                    <th style={{ minWidth: 120 }}>Mã TK sổ quỹ</th>
                    <th style={{ minWidth: 120 }}>Tài khoản quỹ</th>
                    <th style={{ minWidth: 120 }}>Số dư TK quỹ</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Danh sách sổ quỹ trống!" />;
        }

        const getAddressText = (street: string, ward: string, district: string, province: string) => {
            const AddArr = [street, ward, district, province]
            if (street == "") {
                return `${ward}, ${district}, ${province}`
            } else {
                return AddArr?.join(', ');
            }
        }

        const gotoDetail = (item: any) => {
            if(!checkRole(props?.user?.roles, ['viewFundaccount'], props?.user?.role)){
                handleActionModal({type: 'roles', data: item})
                return
            }
            router?.push(`/setting/fundaccount/${item?.id}/view`)
        }
        const SetType = (type: string) => {
            let textColor = "";
            switch (type) {
                case 'cash':
                    textColor = "blue"; // Màu chữ cho Tiền mặt là Xanh dương
                    return <span style={{ color: textColor }}>Tiền mặt</span>;
                case 'account':
                    textColor = "orange"; // Màu chữ cho Tài khoản là Cam
                    return <span style={{ color: textColor }}>Tài khoản</span>;
                default:
                    return "";
            }
        }
        const getCheckTotal = (total: number) => {
            const numberFormat = new Intl.NumberFormat();
            if (total < 0) {
                return <span className={"text-danger"}>{numberFormat.format(total)}</span>;
            } else {
                return <span className={"text-success"}>{numberFormat.format(total)}</span>;
            }
        };
        const styleTds = {
            fontWeight: 'bold',
            backgroundColor: '#F8F8FF',
            borderRadius: '10px',
            border: '1px solid white',
        };
        return (
            <tbody style={{ borderSpacing: '20px' }}>
                {data &&
                    data.map((item: any, index: number) => {
                        return (
                            <tr key={index}>
                                <td onClick={() => gotoDetail(item)} style={{ ...styleTds, paddingRight: '10px' }}>
                                    {item?.code}
                                </td>
                                <td onClick={() => gotoDetail(item)} style={{ ...styleTds, paddingRight: '10px' }}>{item?.name}</td>
                                <td style={{ ...styleTds, paddingLeft: '10px' }}>
                                    {getCheckTotal(item?.total)}
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        );
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            {/* {loading && <Loader />} */}
        </div>
    );
}
const DataTitle = (props: any) => {
    return (
        <h3>Sổ quỹ tiền mặt</h3>
    );
};
const DataTitles = (props: any) => {
    return (
        <h3>Sổ quỹ tài khoản</h3>
    );
};

const RenderActionModal = (props: any) => {
  const [loading, setLoading] = useState(false);
  const { closeModal, action } = props;
  return (
    <CardBody className='p-0' style={{width:460}}>
          <div className="modal-header">
              <h5 className="modal-title" id="modal-action-title">
                  Thông báo
              </h5>
              <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
          </div>
          <div className="modal-body pt-2 pb-2">
              <Col md={12}>
                  <FormGroup row className="label-only">
                      <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                          Bạn không có quyền thực hiện thao tác này
                      </p>
                  </FormGroup>
              </Col>
          </div>
          <div className="modal-footer">
              <Button
                  onClick={closeModal}
                  className="ml-2 success-bland" color="success" type="button"
              > Hủy bỏ</Button>
          </div>
          {loading && <Loader />}
      </CardBody>
  )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)